import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=4b5f923b&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ageo\\Documents\\Work\\fhapplication\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5f923b')) {
      api.createRecord('4b5f923b', component.options)
    } else {
      api.reload('4b5f923b', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=4b5f923b&", function () {
      api.rerender('4b5f923b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/auth/components/Register.vue"
export default component.exports